import { render, staticRenderFns } from "./multilingual-disposition.vue?vue&type=template&id=2268ded1&scoped=true"
import script from "./multilingual-disposition.vue?vue&type=script&lang=js"
export * from "./multilingual-disposition.vue?vue&type=script&lang=js"
import style0 from "./multilingual-disposition.vue?vue&type=style&index=0&id=2268ded1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268ded1",
  null
  
)

export default component.exports